var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5654 9.96623H16.6958V5.21829C16.6958 2.0513 15.3393 0.000863104 13.2418 0.000863104C12.6313 -0.0160934 12.0404 0.217387 11.6087 0.649126C11.1757 1.08088 10.9409 1.67044 10.9566 2.28087V4.40958C10.9579 6.14176 10.0878 7.75775 8.64002 8.70874L5.97391 10.4879H0.521743C0.23348 10.4879 0 10.7214 0 11.0096V23.5314C0 23.6697 0.0547819 23.8027 0.152609 23.9006C0.250436 23.9984 0.383481 24.0532 0.521752 24.0532H19.5653C22.0135 24.0506 23.9973 22.0667 24 19.6185V14.401C23.9974 11.9528 22.0136 9.9689 19.5654 9.96623ZM1.04345 11.5315H5.73897V23.0098H1.04345V11.5315ZM22.9566 19.6186C22.954 21.4903 21.4371 23.0071 19.5654 23.0098H6.78279V11.1872L9.21933 9.58022C10.958 8.43499 12.0028 6.49151 12.0002 4.40988V2.28117C11.9846 1.94726 12.1111 1.62376 12.3472 1.38768C12.5846 1.1529 12.9094 1.02769 13.242 1.04465C14.7289 1.04465 15.6524 2.64641 15.6524 5.21859V10.4881C15.6524 10.6264 15.7072 10.7594 15.8051 10.8572C15.9029 10.9551 16.0359 11.0099 16.1742 11.0099H19.5654C21.4372 11.0125 22.954 12.5294 22.9567 14.4011L22.9566 19.6186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeicon);
export default __webpack_public_path__ + "static/media/likeicon.7a43143aacac025cc803d165978986a1.svg";
export { ForwardRef as ReactComponent };